module.exports = __webpack_public_path__ + "static/media/be.b96f7357.svg";